import React from 'react';

//-----------------------|| MINIMAL LAYOUT ||-----------------------//

const MinimalLayout = (props: { children: React.ReactElement | React.ReactElement[] }) => {
  return <React.Fragment>{props.children}</React.Fragment>;
};

export default MinimalLayout;
